export const getNoWxLocation = function(callback, error) {
  navigator.geolocation.getCurrentPosition(
    function(position) {
      // console.log(position);
      var latitude = position.coords.latitude;
      var longitude = position.coords.longitude;
      localStorage.setItem("latitude", latitude);
      localStorage.setItem("longitude", longitude);
      var data = {
        latitude: latitude,
        longitude: longitude,
      };
      // console.log(data);
      if (typeof callback == "function") {
        callback(data);
      }
    },
    function() {
      if (typeof error == "function") {
        error();
      }
    }
  );
};
